import React, { useState, useCallback, useEffect } from 'react'
import { Formik, Form } from 'formik'
import FooterServices from '../../services/footer.service'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import InputError from '../../components/InputError/InputError'
import NeoInput from '../../components/NeoInput/NeoInput'
import NeoButton from '../../components/NeoButton/NeoButton'
import { SuggestionSchema } from '../../schemas/others/suggestions'
import Loading from 'custom/assets/loaders/Loading'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
import Modal from '../../components/Modal/Modal'
import { useModal } from 'react-modal-hook'
import { useHistory } from 'react-router-dom'
import { BUTTON_KEYS, SUPPORT_CENTER_SUGGESTION_KEYS} from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next';
import validationConfig from 'custom/config/validation.config.json'
const suggestionsConfig = validationConfig['OtherService']['suggestions']

export default function Suggestions() {
  const [suggestionsDetails, setSuggestionsDetails] = useState({})
  const [feedbackDetails, setFeedbackDetails] = useState({})
  const [stage, setStage] = useState(0)
  const history = useHistory()
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const {t}=useTranslation()
  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <h6 className='text-center'>{message}</h6>
        <div className='mt-4 col-6 mx-auto'>
          <NeoButton
            tabIndex='1'
            type='button'
            mode='newDesign'
            text={t(BUTTON_KEYS.CLOSE)}
            onClick={() => {
              hideModal()
              history.push('/dashboard')
            }}
          />
        </div>
      </Modal>
    ),
    [message],
  )

  useEffect(() => {
    getComplaintDetails();
  }, []);

  const getComplaintDetails = useCallback(async (values) => {
    try {
      setLoading(true)
      const response = await FooterServices.getComplaintDetails(values);
      if (response.status === 200) {
        setSuggestionsDetails(response.data);
        setStage(1)
        setLoading(false)
      }
    } catch (err) {
      setMessage(err.data.message)
      //showModal()
      setLoading(false)
    }
  }, [showModal]);
  const getFeedbackDetails = useCallback(async (values, { setSubmitting }) => {
    try {
      setSubmitting(true)
      const response = await FooterServices.getFeedbackDetails(values);
      if (response.status === 200) {
        setStage(1)
        setFeedbackDetails(response.data);
      }
      setStage(2)
        setSubmitting(false)
        setMessage(response.data.message)
    } catch (err) {
      setMessage(err.data.message)
        //showModal()
        setSubmitting(false)
    }
  }, [showModal]);

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return suggestionForm()
        case 2:
          return <NeoSuccess message={message} linkPath='/dashboard' />
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function suggestionForm() {
    return (
      <Formik
        initialValues={{
          category: '',
          suggestion: '',
        }}
        enableReinitialize
        validationSchema={SuggestionSchema}
        onSubmit={getFeedbackDetails}>
        {({ isSubmitting, errors, touched, handleChange }) => (
          <Form>
            <div className='form-group'>
              <NeoInput
                tabIndex='1'
                mode='select'
                showAsterisk={suggestionsConfig['isFeedbackCategoryRequired']}
                text={t(SUPPORT_CENTER_SUGGESTION_KEYS.SELECT_FEEDBACK)}
                name='category'
                onChange={handleChange}
                keyValue={null}
                list={Object.keys(suggestionsDetails.values)}
              />
              <InputError text={errors.category} touched={touched.category} />
            </div>

            <div className='my-4 form-group'>
              <NeoInput
                tabIndex='2'
                mode='textarea'
                showAsterisk={suggestionsConfig['isSuggestionRequired']}
                text={t(SUPPORT_CENTER_SUGGESTION_KEYS.WRITE_FEEDBACK)}
                name='suggestion'
                onChange={handleChange}
                rows='7'
                minLength={10}
                maxLength={1000}
              />
              <InputError text={errors.suggestion} touched={touched.suggestion} />
            </div>

            <div className='mt-5 ml-auto col-12 px-0'>
              {isSubmitting === false ? (
                <NeoButton tabIndex='3' type='submit' disabled={isSubmitting} text={t(BUTTON_KEYS.SUBMIT)} mode='newDesign' />
              ) : (
                renderLoading()
              )}
            </div>
          </Form>
        )}
      </Formik>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='SUGGESTION'
      showEmptySpace={true}
      keyPath={'SUGGESTIONS'}>
      <div className='new-design-form-style'>
        <div className='heading-style'>{t(SUPPORT_CENTER_SUGGESTION_KEYS.TITLE)}</div>
        {renderSwitch()}
      </div>
    </LayoutWithOutAccountCard>
  )
}
